import { createAsyncThunk } from "@reduxjs/toolkit";
import { popSuccess, popWarning } from "../alert/alert.slice";
import AxiosConfig from "../../common/axiosConfig";

export const uploadInvoices = createAsyncThunk(
  "invoices/upload",
  async (formData, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await AxiosConfig.post(
        "/v1/invoice/upload-invoices",
        formData
      );

      const erroredFiles = data.filter(({ error }) => error);

      if (erroredFiles.length) {
        // setFiles(
        //   files.filter(({ filename }) =>
        //     erroredFiles.some(
        //       ({ fileName: errorFileName }) => errorFileName === filename
        //     )
        //   )
        // );
        dispatch(
          popWarning({
            title: "Pdf not parsed correctly",
            text: erroredFiles.map(({ fileName }) => fileName).join(" "),
          })
        );
      } else {
        dispatch(
          popSuccess({
            title: "Succesfully Uploaded",
            text: "Thanks for your patience!",
          })
        );
      }
      return data;
    } catch (e) {
      return rejectWithValue(e.message);
    }
  }
);
